export const LEVEL_COLORS = {
  warn: "rgba(255, 165, 0, 0.2)", // orange
  crit: "rgba(255, 0, 0, 0.2)", // red
  info: "rgba(0, 0, 255, 0.2)", // blue
  ok: "rgba(0, 255, 0, 0.2)", // green
  unknown: "rgba(128, 0, 128, 0.2)", // purple
};
